export enum BoxStyle {
  UNKNOWN_BOX_STYLE = 'UNKNOWN_BOX_STYLE',
  JAPANESE = 'JAPANESE',
  WESTERN = 'WESTERN'
}
